import { useContext } from "react";
import { SessionContext, type SessionContextValue } from "./SessionProvider";

/**
 * Returns the current session context value.
 * Must be used within a SessionProvider.
 */
export function useSession(): SessionContextValue {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error("useSession must be used within a SessionProvider");
  }
  return context;
}
